// @flow
import React, {useEffect, useRef, useState} from "react";
import {Table, Col, Divider, Row, Button, Typography, Tooltip} from "antd";
import {useHistory} from "react-router-dom";
import {
    FileSearchOutlined,
    CloseCircleOutlined,
    CheckCircleOutlined,
    InfoCircleOutlined
} from "@ant-design/icons";
import {useTranslation, Trans} from "react-i18next";
import {
    MobileResponsiveWrapper,
    OrderNumber,
    OrderTotalTime,
    TableTitle,
    TableOverflow,
    OrderTableNew,
    DescriptionContainer,
    PrepModalContainer,
    PrepDetailContainer,
    StyledPrepModal
} from "../CustomerOrdersPage.styles.js";
import {
    getConstant,
    isConstantExist,
    truncateString,
    calculateElapsedTime,
    formatPhoneNumber
} from "../../../../utils/helpers.js";
import {deliveryStatuses} from "../../../../constants/constants.js";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton.js";
import {TextBoxFormModal} from "../../../_defaultComponents/TextBoxFormModal/TextBoxFormModal.js";
import {CourierLink} from "../../../_defaultComponents/CourierLink/CourierLink.js";
import {ConditionalTooltip} from "../../../_defaultComponents/ConditionalTooltip/ConditionalTooltip.js";
import {useStore} from "../../../../hooks/useStore.js";
import {ReceiptPrinter} from "../../../_defaultComponents/ReceiptPrinter/ReceiptPrinter.js";
import SplitOrderButton from "../../../customer/customerSplitOrderButton/splitOrderButton.js";
import {EmptyMessage} from "../../../_defaultComponents/EmptyMessage/EmptyMessage.js";
import {CustomerApplyButton} from "../customerApplyButton/CustomerApplyButton.js";
import {TableWrapper} from "../../../_defaultComponents/TableWrapper/TableWrapper";
import {CustomerOrderDetailModal} from "./customerOrderDetailModal/CustomerOrderDetailModal.js";
import {QueueModal} from "./queueModal/QueueModal.js";
import moment from "moment";

const {Text} = Typography;
const {Column} = Table;

const initialText = {
    label: "",
    title: ""
};

export const CustomerOrdersTable = ({
    loading,
    data,
    dataCount,
    setPage,
    currentPage,
    setField,
    field,
    orderType,
    setRecall,
    recallRef,
    setStatsRecall
}) => {
    const history = useHistory();
    const stores = useStore();
    const {t, i18n} = useTranslation(["deliveryStatuses", "orderDetail"]);
    const [queueModalVisible, setQueueModalVisible] = useState(false);
    const [prepModalVisible, setPrepModalVisible] = useState(false);
    const [receiptModalVisible, setReceiptModalVisible] = useState(false);
    const [isReceiptPrinting, setIsReceiptPrinting] = useState(false);
    const receiptRef = useRef();
    const [queueModalIndex, setQueueModalIndex] = useState(0);
    const [queueModalData, setQueueModalData] = useState([]);

    const [prepModalIndex, setPrepModalIndex] = useState(-1);
    const [prepModalData, setPrepModalData] = useState([]);

    const [modalVisible, setModalVisible] = useState(false);
    const [modalType, setModalType] = useState("");
    const [submit, setSubmit] = useState();
    const [deliveryType, setDeliveryType] = useState();
    const [customerOrderDetailModalVisible, setCustomerOrderDetailModalVisible] = useState(false);
    const [deliveryId, setDeliveryId] = useState("");
    const [modalData, setModalData] = useState({
        deliveryId: "",
        orderId: ""
    });
    const [text, setText] = useState(initialText);
    const [availableCouriers, setAvailableCouriers] = useState(null);
    const [preferredCourierValue, setPreferredCourierValue] = useState(null);
    const [forceCourierValue, setForceCourierValue] = useState(null);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orderDate, setOrderDate] = useState(null);
    const [loadingRows, setLoadingRows] = useState({});
    const isOrderPreparedActive = stores.meStore?.companies?.[0]?.isOrderPreparedActive;
    const findCompany = async companyId => {
        const company = await stores.appStore.companyListFilter.find(cm => cm._id === companyId);
        return company;
    };
    const getToken = async ({apiKey, apiSecret}) => {
        try {
            const data = await stores.apiRequestStore.getAuthToken({apiKey, data: {apiSecret}});
            return data.token;
        } catch (err) {
            return null;
        }
    };
    useEffect(() => {
        if (data?.length > 0 && data?.every(e => e.deliveryState === "inQueue")) {
            setQueueModalData(data[queueModalIndex]);
        }
    }, [data, queueModalIndex]);

    useEffect(() => {
        if (
            data?.length > 0 &&
            data?.every(e => e.deliveryState === "inPrep" || e.deliveryState === "unapproved")
        ) {
            setPrepModalData(data[prepModalIndex]);
        }
    }, [data, prepModalIndex]);

    const getAvailableCouriers = async (subCompanyId, courierType) => {
        const availableCouriers = await stores.courierStore.getAvailableCouriersForPreferredCourier(
            {
                subCompanyId,
                courierType,
                allPoolCouriers: true
            },
            false
        );
        setAvailableCouriers(availableCouriers);
    };

    useEffect(() => {
        if (queueModalVisible && queueModalData && queueModalData._id) {
            setPreferredCourierValue(null);
            getAvailableCouriers(queueModalData?.pickupInfos[0]._id, queueModalData.courierType);
        }
    }, [queueModalVisible, queueModalIndex, queueModalData]);

    const displayQueueModal = () => {
        setPreferredCourierValue(null);
        setQueueModalVisible(true);
    };

    const displayPrepModal = () => {
        setPrepModalVisible(true);
    };

    const cancelDelivery = ({type, deliveryId, reason}) => {
        const targetDeliveryId =
            deliveryId || (type === "queue" ? queueModalData?._id : prepModalData?._id);

        stores.orderStore.cancelDelivery({
            cancelText: reason?.label || "Müşteri tarafından iptal edildi",
            cancelKey: reason?.value || "customerCancel",
            deliveryId: targetDeliveryId
        });
        setRecall(prev => !prev);
        setStatsRecall(prev => !prev);
        setModalVisible(false);
        setQueueModalVisible(false);
        setPreferredCourierValue(null);
        setAvailableCouriers(null);
        setPrepModalVisible(false);
        setModalData({deliveryId: "", orderId: ""});
    };

    const cancelQueueDelivery = async ({deliveryId, reason, shouldSendCallback}) => {
        try {
            await stores.orderStore.cancelDelivery({
                cancelText: reason.label,
                cancelKey: reason.value,
                deliveryId,
                shouldSendCallback
            });
            setRecall(prev => !prev);
            setStatsRecall(prev => !prev);
            setQueueModalVisible(false);
            setModalVisible(false);
            setPreferredCourierValue(null);
            setAvailableCouriers(null);
        } catch (error) {
            console.error("İptal işlemi başarısız:", error);
        }
    };
    const requestOrderPreparation = async ({companyId, orders}) => {
        const company = await findCompany(companyId);
        const {apiKey, apiSecret} = company;
        const token = await getToken({apiKey, apiSecret});
        const unpreparedOrders = orders.filter(order => !order.isPrepared);
        for (const order of unpreparedOrders) {
            await stores.orderStore.setOrderPreparation({
                orderNumber: order.orderNumber,
                prepared: true,
                apiKey,
                token
            });
        }
    };
    const approveDelivery = () => {
        stores.orderStore.approveDelivery({
            deliveryId: prepModalData?._id
        });
        setRecall(!recallRef.current);
        setModalVisible(false);
        setPreferredCourierValue(null);
        setQueueModalVisible(false);
        setAvailableCouriers(null);
        setPrepModalVisible(false);
        setModalData({deliveryId: "", orderId: ""});
    };

    const finishPreparation = () => {
        stores.orderStore.finishPreparation({
            deliveryId: prepModalData?._id
        });
        setRecall(!recallRef.current);
        setModalVisible(false);
        setPreferredCourierValue(null);
        setQueueModalVisible(false);
        setAvailableCouriers(null);
        setPrepModalVisible(false);
        setModalData({deliveryId: "", orderId: ""});
    };

    const queueDeliveryType =
        queueModalData?.deliveryType === "productReturn" ? "return" : "delivery";

    const calculateMultiOrderStats = delivery => {
        let totalOrdersCount = delivery?.orders?.length || 0;
        let deliveredOrdersCount = 0;
        let pickedUpOrdersCount = 0;
        if (["current", "burningOrders"].includes(orderType) && delivery?.orders.length > 1) {
            delivery?.orders?.forEach(order => {
                const hasPickedUp = delivery?.pickupInfos?.some(
                    pI =>
                        pI._id.toString() === order.pickupInfoId.toString() && pI.state === "picked"
                );
                if (hasPickedUp) {
                    pickedUpOrdersCount++;
                }

                if (order.state === "delivered") {
                    deliveredOrdersCount++;
                }
            });
        }
        return {
            totalOrdersCount,
            deliveredOrdersCount,
            pickedUpOrdersCount
        };
    };
    const renderActiveDeliveryStatusText = delivery => {
        let content = "-";

        const {
            totalOrdersCount,
            deliveredOrdersCount,
            pickedUpOrdersCount
        } = calculateMultiOrderStats(delivery);

        if (pickedUpOrdersCount > 0 || deliveredOrdersCount > 0) {
            content = (() => (
                <>
                    {t("mergedOrdersStatus.picked", {
                        ns: "orderDetail",
                        pickedUpCount: pickedUpOrdersCount,
                        totalCount: totalOrdersCount
                    })}
                    ,
                    <br />
                    {t("mergedOrdersStatus.delivered", {
                        ns: "orderDetail",
                        deliveredCount: deliveredOrdersCount,
                        totalCount: totalOrdersCount
                    })}
                </>
            ))();
        } else if (
            delivery.deliveryType === "productReturn" &&
            delivery.deliveryState === "returned"
        ) {
            content = t("delivered.name", {ns: "deliveryStatuses"});
        } else if (delivery.deliveryState === "onDeliveryAddress") {
            const endDate = delivery?.steps?.slice(-1)[0]?.endDate;
            const stepIndex =
                endDate && ["delivered", "returned"].includes(delivery?.deliveryState)
                    ? delivery.currentStepIndex + 1
                    : delivery.currentStepIndex - 1;

            const currentStep = delivery.steps[stepIndex];

            if (Boolean(currentStep.trial?.startDate) && !Boolean(currentStep.trial?.endDate)) {
                content = t("onTrial.name", {ns: "deliveryStatuses"});
            } else {
                content = t(
                    `${getConstant(deliveryStatuses, delivery.deliveryState).translation_key}.name`,
                    {
                        ns: "deliveryStatuses"
                    }
                );
            }
        } else if (delivery.deliveryState === "canceled" && delivery.merged == true) {
            content = t("mergedWithAnotherDelivery", {ns: "orderDetail"});
            if (delivery.mergedAt) {
                const deliveryLink = (
                    <a
                        data-testid="mergedDeliveryLink"
                        onClick={() => {
                            setDeliveryId(delivery.mergedAt);
                            setCustomerOrderDetailModalVisible(true);
                        }}
                    />
                );

                content = (
                    <Trans
                        i18nKey={"mergedDeliveryInfo"}
                        t={t}
                        ns="orderDetail"
                        components={{mergedDeliveryLink: deliveryLink}}
                    />
                );
            }
        } else if (isConstantExist(deliveryStatuses, delivery.deliveryState)) {
            content = t(
                `${getConstant(deliveryStatuses, delivery.deliveryState).translation_key}.name`,
                {
                    ns: "deliveryStatuses"
                }
            );
        }
        return <div data-testid="deliveryStatuses">{content}</div>;
    };

    const removePreferredCourier = () => {
        stores.orderStore.removePreferredCourier({
            deliveryId: queueModalData?._id
        });
        setRecall(recallRef.current);
        setModalVisible(false);
        setPreferredCourierValue(null);
        setForceCourierValue(null);
        setQueueModalVisible(false);
        setAvailableCouriers(null);
        setPrepModalVisible(false);
    };

    const removeForceCourier = () => {
        stores.orderStore.removeForceCourier({
            deliveryId: queueModalData?._id
        });
        setRecall(recallRef.current);
        setModalVisible(false);
        setPreferredCourierValue(null);
        setForceCourierValue(null);
        setQueueModalVisible(false);
        setAvailableCouriers(null);
        setPrepModalVisible(false);
    };

    const updatePreferredCourier = () => {
        stores.orderStore.updatePreferredCourier({
            deliveryId: queueModalData?._id,
            courierId: preferredCourierValue
        });
        setRecall(recallRef.current);
        setModalVisible(false);
        setPreferredCourierValue(null);
        setQueueModalVisible(false);
        setForceCourierValue(null);
        setAvailableCouriers(null);
        setPrepModalVisible(false);
    };
    const updateForceCourier = () => {
        stores.orderStore.updateForceCourier({
            deliveryId: queueModalData?._id,
            forceCourierId: forceCourierValue
        });
        setRecall(recallRef.current);
        setModalVisible(false);
        setPreferredCourierValue(null);
        setForceCourierValue(null);
        setQueueModalVisible(false);
        setAvailableCouriers(null);
        setPrepModalVisible(false);
    };

    const renderCompanyName = ({delivery}) => {
        let companyName = delivery.company.companyName;
        if (delivery.orders.length > 1) {
            companyName = delivery.orders.some(order => order?.pickupInfoCompanyName)
                ? delivery.orders.map(order => order?.pickupInfoCompanyName).join(", ")
                : companyName;
        }
        return (
            <ConditionalTooltip
                condition={truncateString(companyName, 40).indexOf("...") > 0}
                text={companyName}
                child={
                    <div data-testid="companyName" style={{maxWidth: "470px"}}>
                        {truncateString(companyName, 40)}
                    </div>
                }
            />
        );
    };

    const renderSubCompany = ({delivery}) => {
        let subCompanyName = delivery.pickupInfos[0].name;
        if (delivery.orders.length > 1) {
            subCompanyName = delivery.orders.some(order => order?.pickupInfoName)
                ? delivery.orders
                      .filter(order => {
                          if (stores.meStore.checkRole("isCompanyUser")) {
                              return (
                                  stores.meStore.auth.companies.includes(
                                      order?.pickupInfoCompanyId?.toString()
                                  ) ||
                                  stores.meStore.auth.subcompanies.includes(
                                      order?.pickupInfoId?.toString()
                                  )
                              );
                          }
                          return true;
                      })
                      .map(order => order?.pickupInfoName)
                      .join(", ")
                : subCompanyName;
        }

        return (
            <ConditionalTooltip
                condition={truncateString(subCompanyName, 40).indexOf("...") > 0}
                text={subCompanyName}
                child={
                    <div data-testid="subCompanyName" style={{maxWidth: "470px"}}>
                        {truncateString(subCompanyName, 40)}
                    </div>
                }
            />
        );
    };

    const renderOrderNumber = ({delivery}) => {
        let orderNumbers = delivery.orders.map(x => x.orderNumber).join(", ");
        if (delivery.orders.length > 1) {
            orderNumbers = delivery.orders.some(order => order?.orderNumber)
                ? delivery.orders
                      .filter(order => {
                          if (stores.meStore.checkRole("isCompanyUser")) {
                              return (
                                  stores.meStore.auth.companies.includes(
                                      order?.pickupInfoCompanyId?.toString()
                                  ) ||
                                  stores.meStore.auth.subcompanies.includes(
                                      order?.pickupInfoId?.toString()
                                  )
                              );
                          }
                          return true;
                      })
                      .map(order => order?.orderNumber)
                      .join(", ")
                : orderNumbers;
        }
        return (
            <ConditionalTooltip
                condition={truncateString(orderNumbers, 16).indexOf("...") > 0}
                text={orderNumbers}
                child={
                    <div data-testid="orderNumber" style={{maxWidth: "470px"}}>
                        {truncateString(orderNumbers, 16)}
                    </div>
                }
            />
        );
    };

    return (
        <MobileResponsiveWrapper>
            <TextBoxFormModal
                isVisible={modalVisible}
                setVisible={() => setModalVisible(!modalVisible)}
                okFunction={submit}
                label={text.label}
                title={text.title}
                modalType={modalType}
                modalData={modalData}
                cancelFn={() => {
                    setModalType("");
                }}
                deliveryType={deliveryType}
                isCustomer={true}
            />
            <QueueModal
                visible={queueModalVisible}
                onCancel={() => {
                    setPreferredCourierValue(null);
                    setQueueModalVisible(false);
                    setAvailableCouriers(null);
                }}
                queueModalData={queueModalData}
                preferredCourierValue={preferredCourierValue}
                setPreferredCourierValue={setPreferredCourierValue}
                forceCourierValue={forceCourierValue}
                setForceCourierValue={setForceCourierValue}
                availableCouriers={availableCouriers}
                updatePreferredCourier={updatePreferredCourier}
                removePreferredCourier={removePreferredCourier}
                updateForceCourier={updateForceCourier}
                removeForceCourier={removeForceCourier}
                cancelDelivery={cancelQueueDelivery}
                setModalVisible={setModalVisible}
                setModalData={setModalData}
                setModalType={setModalType}
                setText={setText}
                setSubmit={setSubmit}
                stores={stores}
                data={data}
                queueModalIndex={queueModalIndex}
            />
            {/*@TODO: split this modal*/}
            {prepModalVisible && (
                <StyledPrepModal
                    width={700}
                    footer={null}
                    visible={prepModalVisible}
                    onCancel={() => {
                        setPrepModalVisible(false);
                    }}
                >
                    <TextBoxFormModal
                        isVisible={modalVisible}
                        setVisible={() => setModalVisible(!modalVisible)}
                        okFunction={submit}
                        label={text.label}
                        title={text.title}
                        modalType={modalType}
                        modalData={modalData}
                        cancelFn={() => {
                            setModalType("");
                        }}
                        deliveryType={deliveryType}
                    />
                    <PrepModalContainer>
                        <OrderNumber>
                            {t("fields.orderNumber", {ns: "common"})}:{" "}
                            {prepModalData?.orders
                                ? prepModalData.orders.map(x => x.orderNumber).join(", ")
                                : "-"}
                        </OrderNumber>
                        {prepModalData?.orders &&
                        prepModalData?.orders[0] &&
                        prepModalData?.orders[0].platformPickingTime ? (
                            <PrepDetailContainer>
                                <TableTitle>{t("other.platformDetail", {ns: "common"})}</TableTitle>
                                <Table
                                    rowKey="_id"
                                    dataSource={prepModalData?.orders}
                                    pagination={false}
                                >
                                    <Column
                                        title={t("other.platformPickingTime", {ns: "common"})}
                                        render={text =>
                                            moment
                                                .utc(text.platformPickingTime)
                                                .format("DD-MM-YYYY HH:mm")
                                        }
                                    />
                                    <Column
                                        title={t("other.platformDeliveryTime", {ns: "common"})}
                                        render={text =>
                                            moment
                                                .utc(text.platformDeliveryTime)
                                                .format("DD-MM-YYYY HH:mm")
                                        }
                                    />
                                    <Column
                                        title={""}
                                        render={text =>
                                            text.isPlatformSlotOrder
                                                ? t("other.platformSlotDelivery", {ns: "common"})
                                                : t("other.platfromQuickDelivery", {ns: "common"})
                                        }
                                    />
                                </Table>
                            </PrepDetailContainer>
                        ) : (
                            ""
                        )}
                        <Row>
                            <div>
                                <Text type="success">{t("fields.start", {ns: "common"})}: </Text>
                                {moment(prepModalData?.createdAt).format("HH:mm:ss")}
                            </div>
                        </Row>
                        <OrderTotalTime>
                            {t("fields.elapsedTime", {ns: "common"})}:{" "}
                            {prepModalData?.deliveryState === "canceled"
                                ? t("canceled.shortName", {
                                      ns: "deliveryStatuses"
                                  })
                                : calculateElapsedTime(prepModalData?.createdAt, new Date())}
                        </OrderTotalTime>
                        <TableTitle>
                            {prepModalData?.deliveryType === "productReturn"
                                ? t("fields.returnPoints", {ns: "common"})
                                : t("fields.deliveryPoints", {
                                      ns: "common"
                                  })}
                        </TableTitle>
                        <TableOverflow>
                            <OrderTableNew
                                rowKey="_id"
                                dataSource={prepModalData?.orders}
                                pagination={false}
                                expandable={{
                                    expandedRowRender: record => {
                                        return (
                                            <>
                                                <Table
                                                    rowKey="_id"
                                                    dataSource={record.products}
                                                    pagination={false}
                                                >
                                                    <Column
                                                        dataIndex="productName"
                                                        title={t("fields.productName", {
                                                            ns: "common"
                                                        })}
                                                    ></Column>
                                                    <Column
                                                        dataIndex="ingredients"
                                                        title={t("fields.productContent", {
                                                            ns: "common"
                                                        })}
                                                    ></Column>
                                                    <Column
                                                        dataIndex="amount"
                                                        title={t("fields.productAmount", {
                                                            ns: "common"
                                                        })}
                                                    ></Column>
                                                </Table>
                                                <Col span={24}>
                                                    <Divider orientation="left">
                                                        {t("fields.orderNote", {ns: "common"})}
                                                    </Divider>
                                                    <p
                                                        style={{
                                                            marginLeft: 40,
                                                            marginRight: 40
                                                        }}
                                                    >
                                                        {record.note}
                                                    </p>
                                                </Col>
                                            </>
                                        );
                                    }
                                }}
                            >
                                <Column
                                    title={
                                        prepModalData?.deliveryType === "productReturn"
                                            ? t("fields.returnPoint", {
                                                  ns: "common"
                                              })
                                            : t("fields.customerName", {
                                                  ns: "common"
                                              })
                                    }
                                    render={text => text.receiverName}
                                ></Column>
                                <Column
                                    title={t("fields.phone", {
                                        ns: "common"
                                    })}
                                    render={text => formatPhoneNumber(text.receiverPhone)}
                                ></Column>
                                <Column
                                    title={t("fields.address", {
                                        ns: "common"
                                    })}
                                    render={text => text.receiverAddress}
                                ></Column>
                                <Column
                                    title={t("fields.addressDetail", {
                                        ns: "common"
                                    })}
                                    render={text => text.receiverAddressDetail}
                                ></Column>
                            </OrderTableNew>
                        </TableOverflow>
                        <TableTitle>
                            {prepModalData?.deliveryType === "productReturn"
                                ? t("fields.returnPickupPoints", {
                                      ns: "common"
                                  })
                                : t("fields.pickupPoints", {
                                      ns: "common"
                                  })}
                        </TableTitle>
                        <Table
                            rowKey="_id"
                            dataSource={prepModalData?.pickupInfos}
                            pagination={false}
                        >
                            <Column
                                title={
                                    prepModalData?.deliveryType === "productReturn"
                                        ? t("fields.customerName", {
                                              ns: "common"
                                          })
                                        : t("fields.warehouseName", {
                                              ns: "common"
                                          })
                                }
                                render={text => text.name}
                            />
                            <Column
                                title={t("fields.phone", {ns: "common"})}
                                render={text => formatPhoneNumber(text.phone)}
                            />
                            <Column
                                title={t("fields.address", {
                                    ns: "common"
                                })}
                                render={text => text.address}
                            />
                        </Table>
                        {stores.meStore.checkRole("notVisibleForCompanyUser") && (
                            <DescriptionContainer>
                                <TableTitle>{t("fields.company", {ns: "common"})}</TableTitle>
                                <div
                                    style={{
                                        padding: "12px",
                                        border: "1px solid #f0f0f0",
                                        borderRadius: "8px"
                                    }}
                                >
                                    <div style={{marginBottom: "12px"}}>
                                        <div
                                            style={{
                                                fontWeight: 600,
                                                fontSize: "13px",
                                                marginBottom: "4px"
                                            }}
                                        >
                                            {t("fields.companyName", {ns: "common"})}
                                        </div>
                                        <div style={{fontSize: "14px"}}>
                                            {prepModalData?.company?.companyName}
                                        </div>
                                    </div>
                                    <div>
                                        <div
                                            style={{
                                                fontWeight: 600,
                                                fontSize: "13px",
                                                marginBottom: "4px"
                                            }}
                                        >
                                            {t("fields.createdDate", {ns: "common"})}
                                        </div>
                                        <div style={{fontSize: "14px"}}>
                                            {moment(prepModalData?.company?.createdAt)
                                                .locale(i18n.resolvedLanguage || "tr")
                                                .format("ll")}
                                        </div>
                                    </div>
                                </div>
                            </DescriptionContainer>
                        )}
                        <Row justify="end" style={{marginTop: "8px"}}>
                            {(prepModalData?.deliveryState === "unapproved" ||
                                prepModalData?.deliveryState === "inPrep") && (
                                <Button
                                    style={{marginRight: "10px"}}
                                    type="primary"
                                    onClick={() => {
                                        setModalVisible(!modalVisible);
                                        setModalData({
                                            type: "prep",
                                            deliveryId: prepModalData?._id
                                        });
                                        setModalType("");

                                        if (prepModalData?.deliveryState === "unapproved") {
                                            setModalType("unapproved");
                                            setText({});
                                            setSubmit(() => approveDelivery);
                                        } else if (prepModalData?.deliveryState === "inPrep") {
                                            setModalType("inPrep");
                                            setText({});
                                            setSubmit(() => finishPreparation);
                                        }
                                    }}
                                    icon={
                                        prepModalData?.deliveryState === "unapproved" ||
                                        prepModalData?.deliveryState === "inPrep" ? (
                                            <CheckCircleOutlined />
                                        ) : (
                                            undefined
                                        )
                                    }
                                >
                                    {prepModalData?.deliveryState === "unapproved" &&
                                        t("actions.approveOrder", {
                                            ns: "orderPage"
                                        })}
                                    {prepModalData?.deliveryState === "inPrep" &&
                                        t("actions.assignCourier", {
                                            ns: "orderPage"
                                        })}
                                </Button>
                            )}
                            {stores.meStore.checkRole("cancelRepeatOrder") && (
                                <Button
                                    type="danger"
                                    onClick={() => {
                                        setModalVisible(!modalVisible);
                                        setModalData({
                                            type: "prep",
                                            deliveryId: prepModalData?._id
                                        });
                                        setModalType("cancel");
                                        setText({
                                            label: "Sipariş iptal sebebi",
                                            title: "Sipariş iptal"
                                        });
                                        setSubmit(() => cancelDelivery);
                                    }}
                                    icon={<CloseCircleOutlined />}
                                >
                                    {t("actions.cancelOrder", {
                                        ns: "common"
                                    })}
                                </Button>
                            )}
                        </Row>
                    </PrepModalContainer>
                </StyledPrepModal>
            )}
            <TableWrapper
                loading={loading}
                dataSource={data}
                rowKey="_id"
                data-testid="orderTable"
                pagination={{
                    total: dataCount,
                    current: currentPage,
                    onChange: async page => {
                        setPage(page);
                    },
                    hideOnSinglePage: true,
                    showSizeChanger: false
                }}
                style={{marginTop: 16}}
                locale={{
                    emptyText: <EmptyMessage />
                }}
                scroll={{x: "max-content"}}
                display={data?.length > 0 ? "grid" : "flex"}
                dataTitles={(() => {
                    const titles = [];

                    // Detail button
                    titles.push(data?.length > 0 ? t("actions.detail", {ns: "common"}) : "");

                    // Company (if visible)
                    if (stores.meStore.checkRole("notVisibleForCompanyUser")) {
                        titles.push(t("fields.company", {ns: "common"}));
                    }

                    // Order number
                    titles.push(t("fields.orderNo", {ns: "common"}));

                    // Created at
                    titles.push(t("fields.createdAt", {ns: "common"}));

                    // Subcompany
                    titles.push(t("fields.subcompany", {ns: "common"}));

                    // Customer name
                    titles.push(t("fields.customerNameOrReceiptNumber", {ns: "common"}));

                    // Courier (preferred or assigned)
                    if (orderType === "inQueue") {
                        titles.push(t("fields.preferredCourier", {ns: "common"}));
                    } else {
                        titles.push(t("fields.courier", {ns: "common"}));
                    }

                    // Force courier for inQueue
                    if (orderType === "inQueue") {
                        titles.push(t("fields.forceCourier", {ns: "common"}));
                    }

                    // Delivery status
                    titles.push(t("fields.deliveryStatus", {ns: "common"}));

                    // Elapsed time
                    titles.push(t("fields.elapsedTime", {ns: "common"}));

                    // Last action time for burning orders
                    if (orderType === "burningOrders") {
                        titles.push(t("fields.lastActionTime", {ns: "common"}));
                    }

                    // Order prepared active
                    if (
                        data?.some(row => row.pickupInfos?.[0]?.isOrderPreparedActive) &&
                        isOrderPreparedActive
                    ) {
                        titles.push("Sipariş Hazır");
                    }

                    // Split order
                    if (
                        orderType === "current" &&
                        data?.some(row => row.integrationType === "dedicatedIntegration") &&
                        stores.meStore.checkRole("canSplitDeliveries")
                    ) {
                        titles.push("Siparişi Ayır");
                    }

                    // Receipt button - empty title
                    titles.push("");

                    return titles;
                })()}
            >
                <Column
                    title={t("actions.detail", {ns: "common"})}
                    dataIndex="_id"
                    render={(text, row, index) => {
                        return (
                            <Col>
                                <CustomButton
                                    data-testid="detailButton"
                                    onClick={event => {
                                        if (orderType === "inQueue") {
                                            setQueueModalIndex(index);
                                            displayQueueModal();
                                        } else if (orderType === "inPrep") {
                                            setPrepModalIndex(index);
                                            displayPrepModal();
                                        } else {
                                            setCustomerOrderDetailModalVisible(true);
                                            setDeliveryId(text);
                                        }
                                    }}
                                    icon={<FileSearchOutlined />}
                                />
                            </Col>
                        );
                    }}
                />
                {stores.meStore.checkRole("notVisibleForCompanyUser") && (
                    <Column
                        title={t("fields.company", {ns: "common"})}
                        dataIndex="company"
                        render={(_, delivery) => renderCompanyName({delivery})}
                    />
                )}

                <Column
                    title={t("fields.orderNo", {ns: "common"})}
                    dataIndex="currentOrderNumber"
                    render={(_, delivery) => renderOrderNumber({delivery})}
                />
                <Column
                    title={t("fields.createdAt", {ns: "common"})}
                    dataIndex="createdAt"
                    render={text => (
                        <div data-testid="createdAt">
                            {moment(text)
                                .locale(i18n.resolvedLanguage || "tr")
                                .format("lll")}
                        </div>
                    )}
                />
                <Column
                    title={t("fields.subcompany", {ns: "common"})}
                    dataIndex="pickupInfos"
                    render={(_, delivery) => renderSubCompany({delivery})}
                />
                <Column
                    title={t("fields.customerNameOrReceiptNumber", {ns: "common"})}
                    dataIndex="orders"
                    render={text => {
                        const customerNames = text
                            .map(order => order.receiverName || order.receiptNumber)
                            .join(", ");
                        return (
                            <div data-testid="customerNameOrReceiptNumber">
                                <Tooltip title={customerNames}>
                                    {truncateString(customerNames, 30)}
                                </Tooltip>
                            </div>
                        );
                    }}
                />
                {orderType === "inQueue" ? (
                    <Column
                        title={t("fields.preferredCourier", {ns: "common"})}
                        dataIndex="preferredCourier"
                        render={(text, record) => (
                            <div data-testid="courier">
                                {text && text.fullname ? (
                                    text.fullname
                                ) : !text && record.requestedBy ? (
                                    <CustomerApplyButton
                                        setRecall={setRecall}
                                        deliveryId={record._id}
                                        courierName={record.requestedBy.fullname}
                                        courierId={record.requestedBy._id}
                                    />
                                ) : (
                                    "-"
                                )}
                            </div>
                        )}
                    />
                ) : (
                    <Column
                        title={t("fields.courier", {ns: "common"})}
                        dataIndex="assignedCourier"
                        render={courier => (
                            <div data-testid="courier">
                                {courier && stores.meStore.checkRole("courierDetail") ? (
                                    <CourierLink target="_blank" to={`/couriers/${courier?._id}`}>
                                        {courier && courier.fullname ? courier.fullname : "-"}
                                    </CourierLink>
                                ) : courier && courier.fullname ? (
                                    courier.fullname
                                ) : (
                                    "-"
                                )}
                            </div>
                        )}
                    />
                )}

                {orderType === "inQueue" && (
                    <Column
                        title={t("fields.forceCourier", {ns: "common"})}
                        dataIndex="forceCourier"
                        render={(text, record) => (
                            <div data-testid="courier">
                                {text && text.fullname ? text.fullname : "-"}
                            </div>
                        )}
                    />
                )}

                <Column
                    title={t("fields.deliveryStatus", {ns: "common"})}
                    dataIndex="summary"
                    render={(summary, delivery) => {
                        if (orderType === "past" && summary && summary?.types?.length !== 0) {
                            const statusesText = summary.types.map(type =>
                                t(`orderStatuses.summary.${type}`, {
                                    ns: "orderPage"
                                })
                            );
                            return (
                                <div data-testid="deliveryStatuses" style={{wordBreak: "unset"}}>
                                    {statusesText}
                                </div>
                            );
                        } else {
                            return renderActiveDeliveryStatusText(delivery);
                        }
                    }}
                />

                {orderType === "current" ||
                orderType === "burningOrders" ||
                orderType === "inQueue" ||
                orderType === "inPrep" ||
                orderType === "inSlot" ? (
                    <Column
                        sorter={() => {
                            setField({
                                field: "createdAt",
                                asc: !field.asc
                            });
                        }}
                        title={t("fields.elapsedTime", {ns: "common"})}
                        dataIndex="createdAt"
                        render={value => (
                            <div data-testid="elapsedTime">
                                {calculateElapsedTime(value, new Date())}
                            </div>
                        )}
                    />
                ) : (
                    <Column
                        title={t("fields.elapsedTime", {ns: "common"})}
                        dataIndex="steps"
                        render={(value, delivery) => {
                            const sortedSteps = value.sort((a, b) =>
                                new Date(b.stepIndex) > new Date(a.stepIndex) ? -1 : 1
                            );
                            return (
                                <div data-testid="elapsedTime">
                                    {sortedSteps[sortedSteps.length - 1]?.endDate
                                        ? calculateElapsedTime(
                                              delivery.createdAt,
                                              sortedSteps[sortedSteps.length - 1].endDate
                                          )
                                        : !["canceled", "returned"].includes(delivery.deliveryState)
                                        ? calculateElapsedTime(delivery.createdAt, new Date())
                                        : t("canceled.shortName", {ns: "deliveryStatuses"})}
                                </div>
                            );
                        }}
                    />
                )}
                {orderType === "burningOrders" ? (
                    <Column
                        title={t("fields.lastActionTime", {ns: "common"})}
                        dataIndex="steps"
                        render={(value, delivery) => (
                            <div data-testid="elapsedTime">
                                <Tooltip
                                    title={
                                        delivery?.activeStep?.startDate
                                            ? moment(delivery?.activeStep?.startDate)
                                                  .locale(i18n.resolvedLanguage || "tr")
                                                  .format("lll")
                                            : ""
                                    }
                                >
                                    {delivery?.activeStep?.startDate ? (
                                        <Col>
                                            {moment
                                                .duration(
                                                    moment(delivery?.activeStep?.startDate).diff(
                                                        moment()
                                                    )
                                                )
                                                .locale(
                                                    i18n.resolvedLanguage === "tr" ? "tr" : "en"
                                                )
                                                .humanize(true)}{" "}
                                            <InfoCircleOutlined />
                                        </Col>
                                    ) : (
                                        ""
                                    )}
                                </Tooltip>
                            </div>
                        )}
                    />
                ) : (
                    <></>
                )}
                {data?.some(row => row.pickupInfos?.[0]?.isOrderPreparedActive) &&
                    isOrderPreparedActive && (
                        <Column
                            title="Sipariş Hazır"
                            dataIndex="_id"
                            render={(text, row) => {
                                if (!row.pickupInfos?.[0]?.isOrderPreparedActive) {
                                    return null;
                                }
                                const orders = row?.orders || [];
                                const isReady = !orders.some(order => !order.isPrepared);
                                return (
                                    <CustomButton
                                        data-testid="readyOrderButton"
                                        type="primary"
                                        disabled={isReady}
                                        loading={loadingRows[row._id]}
                                        onClick={async () => {
                                            try {
                                                setLoadingRows(prev => ({
                                                    ...prev,
                                                    [row._id]: true
                                                }));
                                                await requestOrderPreparation({
                                                    companyId: row?.pickupInfos?.[0]?.companyId,
                                                    orders
                                                });
                                                stores.appStore.showSuccessMessage({
                                                    content: "Sipariş hazır bildirimi gönderildi"
                                                });
                                                setRecall(!recallRef.current);
                                            } catch (error) {
                                                console.log(error);
                                            } finally {
                                                setLoadingRows(prev => ({
                                                    ...prev,
                                                    [row._id]: false
                                                }));
                                            }
                                        }}
                                        icon={<CheckCircleOutlined />}
                                    >
                                        {isReady
                                            ? "Tüm Siparişler Hazır"
                                            : "Tüm Siparişleri Hazırla"}
                                    </CustomButton>
                                );
                            }}
                        />
                    )}
                {orderType === "current" &&
                    data?.some(row => row.integrationType === "dedicatedIntegration") &&
                    stores.meStore.checkRole("canSplitDeliveries") && (
                        <Column
                            title="Siparişi Ayır"
                            dataIndex="_id"
                            render={(text, row) => {
                                if (row.integrationType !== "dedicatedIntegration") {
                                    return "-";
                                }
                                return (
                                    <SplitOrderButton
                                        deliveryId={row._id}
                                        delivery={row}
                                        deliveryType={row.deliveryType}
                                        orders={row.orders}
                                        reasonOptions={{
                                            defaultValue: "cancelDueToCompany"
                                        }}
                                        onSplitComplete={() => {
                                            setRecall(!recallRef.current);
                                        }}
                                    />
                                );
                            }}
                        />
                    )}
                <Column
                    title={""}
                    dataIndex="_id"
                    render={(text, row, index) => {
                        const orders = row?.orders || [];
                        const rowOrderId = row.orders.map(rowOrder => rowOrder._id);
                        const rowOrder = orders?.find(order => {
                            return order?._id === rowOrderId?.[0];
                        });
                        const order = orders?.length === 1 ? orders[0] : null;

                        return (
                            <Row gutter={[10, 10]}>
                                {order ? (
                                    <Col>
                                        <Button
                                            type="primary"
                                            onClick={() => {
                                                setSelectedOrder(rowOrder);
                                                setOrderDate(row?.createdAt);
                                                setReceiptModalVisible(true);
                                            }}
                                        >
                                            Fişi görüntüle
                                        </Button>
                                    </Col>
                                ) : null}
                            </Row>
                        );
                    }}
                />
            </TableWrapper>
            <ReceiptPrinter
                receiptModalVisible={receiptModalVisible}
                setReceiptModalVisible={setReceiptModalVisible}
                order={selectedOrder}
                createdAt={orderDate}
                receiptRef={receiptRef}
                setIsReceiptPrinting={setIsReceiptPrinting}
                isReceiptPrinting={isReceiptPrinting}
            />
            <CustomerOrderDetailModal
                visible={customerOrderDetailModalVisible}
                onCancel={() => {
                    setCustomerOrderDetailModalVisible(false);
                    setDeliveryId("");
                }}
                deliveryId={deliveryId}
            />
        </MobileResponsiveWrapper>
    );
};
